<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Gerenciamento de Cliente/Fornecedor</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row>
          <vs-input
            label="CPF/CNPJ do Cliente/Fornecedor: "
            v-mask="
              searchDocument.length <= 14
                ? '###.###.###-##'
                : '##.###.###/####-##'
            "
            v-model="searchDocument"
            v-on:keyup.13="findClient(searchDocument)"
          />
          <vs-input
            v-if="searchDocument.length <= 14"
            type="date"
            label="Data de nascimento (CPF): "
            v-model="nascClient"
            v-on:keyup.13="findClient(searchDocument)"
          />
        </vs-row>
        <vs-row style="margin-top: 10px">
          <vs-button
            style="width: 100%; margin: 5px 0"
            icon="search"
            @click="findClient(searchDocument)"  
          > 
            Localizar
          </vs-button>
        </vs-row>

        <vs-row>
          <vs-row v-if="clientExisting" style="margin-top: 10px">
            <vs-alert
              color="#1F74FF"
              closable
              :active.sync="clientExisting"
              close-icon="close"
            >
              <vs-col>
                Cliente Existente no Sistema! <br />
                <b>Código do Cliente: {{ this.client.CODCFO }}</b>
              </vs-col>
            </vs-alert>
          </vs-row>
          <vs-card style="margin-top: 15px" v-if="showClientForm" :key="clientExisting">
            <div slot="header">
              <h3>Informações do Cliente</h3>
            </div>
            <div class="spacing-children">
              <form>
                <vs-row>
                  <vs-col vs-w="8" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="NOME"
                      type="text"
                      v-model="client.NOME"
                      :disabled="!!client.CODCFO || clientExisting || (client.NOME != '' && client.PESSOAFISOUJUR != 'J')"
                      label="Nome Completo"
                      :danger="!client.NOME.length > 0"
                      danger-text="Campo obrigatório!"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                    <vs-select
                      width="100%"
                      name="PESSOAFISOUJUR"
                      :disabled="true"
                      v-model="client.PESSOAFISOUJUR"
                      label="Tipo de Pessoa"
                      placeholder="Selecione"
                      :danger="!client.PESSOAFISOUJUR.length > 0"
                      danger-text="Campo obrigatório!"
                    >
                      <vs-select-item value="F" text="Pessoa Física" />
                      <vs-select-item value="J" text="Pessoa Jurídica" />
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="NOMEFANTASIA"
                      type="text"
                      v-model="client.NOMESOCIAL"
                      label="Nome Fantasia"
                      :disabled="!!client.CODCFO || clientExisting"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="DTNASCIMENTO"
                      type="date"
                      v-if="client.PESSOAFISOUJUR != 'J'"
                      v-model="client.DTNASCIMENTO"
                      label="Data de Nascimento"
                      :disabled="!!client.CODCFO || clientExisting || client.PESSOAFISOUJUR == 'J' || !editDate"
                      :danger="
                        client.DTNASCIMENTO == '' ||
                        validClientAge(client.DTNASCIMENTO)
                      "
                      danger-text="Campo obrigatório para pessoa física, cliente deve ser maior de 18 anos."
                    />
                  </vs-col>

                  <vs-col vs-w="2" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="CGCCFO"
                      type="text"
                      v-model="client.CGCCFO"
                      v-mask="
                        client.CGCCFO.length <= 14
                          ? '###.###.###-##'
                          : '##.###.###/####-##'
                      "
                      label="CPF/CNPJ"
                      :disabled="true"
                      :danger="!client.CGCCFO.length > 0"
                      danger-text="Campo obrigatório!"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="TELEFONE"
                      type="text"
                      v-model="client.TELEFONE"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 1"
                      :danger="
                        !validTelephone(client.TELEFONE) ||
                        client.TELEFONE == client.TELEX
                      "
                      danger-text="Campo obrigatório, os telefones devem ser diferentes"
                    />
                  </vs-col>

                  <vs-col vs-w="6" vs-xs="12" vs-type="flex">
                    <vs-input
                      name="TELEX"
                      type="text"
                      v-model="client.TELEX"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 2"
                      :danger="
                        !validTelephone(client.TELEX) ||
                        client.TELEFONE == client.TELEX
                      "
                      danger-text="Campo obrigatório, os telefones devem ser diferentes"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-type="flex">
                    <vs-input
                      name="EMAIL"
                      type="email"
                      v-model="client.EMAIL"
                      label="E-Mail"
                      :danger="
                        !client.EMAIL.length > 0 || !validEmail(client.EMAIL)
                      "
                      danger-text="Campo obrigatório, informe um e-mail válido."
                    />
                  </vs-col>
                </vs-row>
                <div>
                  <vs-divider />
                  <vs-row>
                    <h3>Endereço do Cliente</h3>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-type="flex" vs-w="2" vs-xs="12">
                      <vs-input
                        name="CEP"
                        type="text"
                        v-mask="'########'"
                        v-model="client.CEP"
                        label="CEP"
                        :danger="!validCEP(client.CEP)"
                        danger-text="Informe um CEP válido."
                        v-on:blur="getAddressByCEP(client.CEP)"
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="7" vs-xs="12">
                      <vs-input
                        name="RUA"
                        type="rua"
                        v-model="client.RUA"
                        label="Rua"
                        :danger="
                          !client.RUA.length > 0 || client.RUA.length > 60
                        "
                        danger-text="O campo endereço não pode ser vazio ou ter mais que 60 caracteres!"
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-xs="6">
                      <vs-input
                        name="NUMERO"
                        type="text"
                        v-model="client.NUMERO"
                        label="Número"
                        :danger="!client.NUMERO.length > 0"
                        danger-text="Informe um número válido."
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="2" vs-xs="6">
                      <vs-input
                        name="COMPLEMENTO"
                        type="text"
                        v-model="complement"
                        label="Complem."
                      ></vs-input>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="3" vs-xs="12" vs-type="flex">
                      <vs-select
                        name="ESTADO"
                        width="100%"
                        v-model="client.ESTADO"
                        :danger="client.ESTADO == ''"
                        danger-text="Estado obrigatório!"
                        label="Estado"
                        v-on:input="changeProvinces($event)"
                      >
                        <vs-select-item
                          v-for="(option, i) in selectESTADOcli"
                          :key="i"
                          :value="option.CODIGO"
                          :text="option.NOME"
                        >
                        </vs-select-item>
                      </vs-select>
                    </vs-col>

                    <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                      <vs-select
                        name="CODMUNICIPIO"
                        width="100%"
                        v-model="client.CODMUNICIPIO"
                        label="Cidade"
                        :danger="
                          client.CODMUNICIPIO == '' ||
                          client.CODMUNICIPIO == '-'
                        "
                        danger-text="Cidade obrigatória!"
                      >
                        <vs-select-item
                          v-for="(municipio, i) in selectCODMUNICIPIOcli"
                          :key="i"
                          :value="municipio.value.CODIGO"
                          :text="municipio.title"
                        />
                      </vs-select>
                    </vs-col>
                    <vs-col vs-w="4" vs-xs="12" vs-type="flex">
                      <vs-input
                        name="BAIRRO"
                        type="text"
                        v-model="client.BAIRRO"
                        label="Bairro"
                        :danger="!client.BAIRRO.length > 0"
                        danger-text="Informe o bairro."
                      ></vs-input>
                    </vs-col>
                  </vs-row>
                </div>
              </form>
            </div>
          </vs-card>
        </vs-row>
        <vs-row v-if="errorClient" style="margin-top: 10px">
          <vs-alert
            title="Atenção!"
            class="margin"
            color="danger"
            v-for="(error, i) in errorClient"
            :key="i"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
        <vs-row v-if="showClientForm">
          <vs-col vs-type="flex" vs-justify="center">
            <vs-button
              :icon="clientExisting ? 'edit' : 'check_circle'"
              color="#139B0E"
              class="btn-mailing"
              @click="saveAndGoFoward()"
            >
              {{ clientExisting ? "Alterar" : "Cadastrar" }}
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row v-if="success" style="margin-top: 10px">
          <vs-alert
            color="success"
            closable
            :active.sync="success"
            close-icon="close"
          >
            <vs-col>
              Cliente {{ clientExisting ? "Alterado" : "Cadastrado" }} com
              Sucesso! <br />
              <b>Código do Cliente: {{ this.client.CODCFO }}</b>
            </vs-col>
          </vs-alert>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { formatDateToUSA, notifyError } from "../helpers";
import PersonService from "../services/person";
import SerproService from "../services/serpro";
import MailingService from "../services/mailing";
import AuditService from "../services/audits";
import CNPJService from "../services/apiCNPJ.js";
//import { search } from "core-js/fn/symbol";

export default {
  data: () => ({
    searchDocument: "",
    address: null,
    complement: "",
    client: {
      NOMESOCIAL: "",
      NOME: "",
      CGCCFO: "",
      TELEFONE: "",
      TELEX: "",
      EMAIL: "",
      PESSOAFISOUJUR: "",
      DTNASCIMENTO: "",
      isNew: false,
      RUA: "",
      CEP: "",
      NUMERO: "",
      CODMUNICIPIO: "",
      ESTADO: "",
      BAIRRO: "",
      TIPORUA: "",
    },
    selectESTADOcli: [],
    selectCODMUNICIPIOcli: [],
    errorClient: null,
    clientExisting: false,
    showClientForm: false,
    success: false,
    editDate: false,
    nascClient: "",
    resultSerpro: null,
    resultCNPJ: null,
    cpfmenor: false,
    offer: null,
  }),
  name: "ClientSupplier",
  mounted() {
    this.getStates();
    this.changeProvinces("RS");
  },
  methods: {
    getStates() {
      new MailingService()
        .getStates()
        .then((res) => {
          this.selectESTADOcli = res.data;
        })
        .catch((error) => {
          console.error("Error trying to fetch states and provinces", error);
        });
    },

    getAddressByCEP(cep) {
      if (this.validCEP(cep)) {
        this.$vs.loading();
        new AuditService()
          .getAddressByCEP(cep)
          .then((res) => {
            this.address = res.data;
            this.client.RUA = this.address.LOGRADOURO;
            if(!this.client.NUMERO){
              this.client.NUMERO = "";}
            this.complement = "";
            this.client.ESTADO = this.address.UF;
            this.client.BAIRRO = this.address.BAIRRO;
            this.client.CODMUNICIPIO = this.address.CODMUNICIPIO;
            this.client.TIPORUA = this.address.CODTIPORUA;
            this.errorCEP = false;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.client.RUA = "";
            this.client.NUMERO = "";
            this.complement = "";
            this.client.ESTADO = "RS";
            this.client.BAIRRO = "";
            this.client.CODMUNICIPIO = "";
            this.client.TIPORUA = "";
            this.errorCEP = true;
            notifyError(
              this,
              "CEP não encontrado, preencha o endereço manualmente"
            );
            this.$vs.loading.close();
          });
      } else {
        notifyError(this, "CEP inválido!");
      }
    },

    changeProvinces(state) {
      this.$vs.loading();
      new MailingService()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.selectCODMUNICIPIOcli = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
          this.$vs.notify({
            fixed: true,
            title: "Erro ao buscar cidades do estado " + state,
            color: "danger",
            icon: "close",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async findSerpro(cpf, nascimento) {
      this.resultSerpro = null;
      this.cpfmenor = false;
      this.$vs.loading();
      await new SerproService()
        .get(cpf.replace(/\D/g, ""), nascimento)
        .then(({ data }) => {
          this.resultSerpro = data;
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (!response) {
            this.errorClient.push("Falha de comunicação com o serviço Serpro.");
          } else {
            if (response.status == 400)
              this.errorClient.push("CPF ou data de nascimento inválidos");
            if (response.status == 404)
              this.errorClient.push(
                "CPF não localizado ou data de nascimento não confere com a Receita Federal"
              );
            if (response.status == 422 || response.status == 451) {
              this.errorClient.push(
                "CPF de menor de idade, não é possível buscar as informações. Preencha o formulário."
              );
              this.cpfmenor = true;
            }
            if (response.status >= 500)
              this.errorClient.push(
                "O serviço de busca CPF parece não estar respondendo. Aguarde uns instantes e tente novamente."
              );
          }
          this.$vs.loading.close();
        });
    },

    async findClient(cpf) {
      this.resetClient(cpf);
      this.errorClient = [];
      this.client.CGCCFO = cpf;
      let clientResult = null;
      this.clientExisting = false;
      this.showClientForm = false;
      
      clientResult = await this.find(cpf, "C");

      if (clientResult) {
        this.clientExisting = true;
        if (clientResult.INADIMPLENTE == "1") {
          this.errorClient.push("Cliente não pode ser selecionado, pois o mesmo consta como inadimplente.");
        }
        if (parseInt(clientResult.IDADE) < 18 && clientResult.IDADE != "0") {
          this.errorClient.push("Responsável financeiro precisa ser maior de 18 anos.");
        }
        if (this.errorClient.length == 0) {
          Object.assign(this.client, clientResult);
          this.client.TELEFONE = this.client.TELEFONE1 || "";
          this.client.TELEX = this.client.TELEFONE2 || "";
          
          if (!this.client.NOMESOCIAL || this.client.NOMESOCIAL == "-" || this.client.NOMESOCIAL == "[object Object]") {
            this.client.NOMESOCIAL = this.client.NOME;
          }

          if (this.client.DTNASCIMENTO && this.client.DTNASCIMENTO != "-") {
            this.client.DTNASCIMENTO = formatDateToUSA(this.client.DTNASCIMENTO);
            this.editDate = false;
          } else {
            this.client.DTNASCIMENTO = "";
            this.editDate = true;
          }
          this.showClientForm = true;
        }
      } else {
        const cleanCpf = cpf.replace(/\D/g, "");
        
        if (cleanCpf.length == 11) {
          //SERPRO v3 EXIGE A DATA DE NASCIMENTO JUNTO COM O CPF
          if (!this.nascClient) {
            this.errorClient.push(
              "CPF não cadastrado na QI. Informe a data de nascimento e clique em Localizar."
            );
            return;
          }
          await this.findSerpro(cpf, this.nascClient);
          if (this.resultSerpro) {
            this.client.NOME = this.resultSerpro.nome || "";
            this.client.DTNASCIMENTO = this.resultSerpro.nascimento ? formatDateToUSA(this.resultSerpro.nascimento) : "";
            this.client.PESSOAFISOUJUR = "F";
            this.client.NOMESOCIAL = this.client.NOME;
            this.editDate = false;
            this.showClientForm = true;
          }
        } else if (cleanCpf.length > 11) {
          await this.findCNPJ(cpf);
          if (this.resultCNPJ) {
            const est = this.resultCNPJ.estabelecimento || {};
            
            this.client.NOME = this.resultCNPJ.razao_social || "";
            this.client.PESSOAFISOUJUR = "J";
            this.client.NOMESOCIAL = est.nome_fantasia || this.client.NOME;
            
            // Tratamento seguro de Telefone 1
            if (est.telefone1) {
              this.client.TELEFONE = (est.telefone1.length < 10 && est.ddd1) 
                ? est.ddd1 + est.telefone1 
                : est.telefone1;
            } else {
              this.client.TELEFONE = "";
            }

            // Tratamento seguro de Telefone 2
            if (est.telefone2) {
              this.client.TELEX = (est.telefone2.length < 10 && est.ddd2) 
                ? est.ddd2 + est.telefone2 
                : est.telefone2;
            } else {
              this.client.TELEX = "";
            }

            this.client.EMAIL = est.email || "";
            this.client.CEP = est.cep || "";
            
            if (this.client.CEP) {
              this.getAddressByCEP(this.client.CEP);
            }
            
            this.client.NUMERO = est.numero || "";
            this.editDate = false;
            this.showClientForm = true;
          }
        }
      }
    },
    resetClient() {
      this.client = {
        CGCCFO: "",
        CODCOLCFO: "",
        CODCFO: "",
        NOMESOCIAL: "",
        NOME: "",
        TELEFONE: "",
        TELEX: "",
        EMAIL: "",
        PESSOAFISOUJUR: "",
        DTNASCIMENTO: "",
        RUA: "",
        CEP: "",
        NUMERO: "",
        COMPLEMENTO: "",
        CODMUNICIPIO: "",
        ESTADO: "",
        BAIRRO: "",
        TIPORUA: "",
      };
    },

    validTelephone(telephone) {
      var re = /^(\(?\d{2}\)?\s)(\d{4}?-\d{4,5})$/;
      return re.test(telephone);
    },
    validCEP(cep) {
      var re = /^\d{5}\d{3}$/;
      return re.test(cep);
    },

    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validClientAge(birthDay) {
      return moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") < 18;
    },

    validAddress() {
      if (
        this.client.RUA != "" &&
        this.client.NUMERO != "" &&
        this.client.ESTADO != "" &&
        this.client.BAIRRO != "" &&
        this.client.CODMUNICIPIO != "" &&
        this.client.CODMUNICIPIO != "-" &&
        this.validCEP(this.client.CEP)
      ) {
        return true;
      } else return false;
    },

    validClientData() {
      this.errorClient = [];
      if (!this.validEmail(this.client.EMAIL))
        this.errorClient.push("E-mail do responsável financeiro inválido.");
      if (this.validClientAge(this.client.DTNASCIMENTO))
        this.errorClient.push(
          "Data de nascimento do responsável inválida. Lembramos que o responsável financeiro precisa ter 18 anos completos."
        );
      if (!this.validTelephone(this.client.TELEFONE))
        this.errorClient.push("Telefone 1 do responsável inválido.");
      if (!this.validTelephone(this.client.TELEX))
        this.errorClient.push("Telefone 2 do responsável inválido.");
      if (this.client.NOME == "")
        this.errorClient.push("O nome do cliente precisa ser preenchido");
      if (!this.validAddress())
        this.errorClient.push("Preencha o endereço do cliente!");
    },

    async find(cpf, type) {
      this.$vs.loading();
      let result = null;
      await new PersonService()
        .getPerson(cpf.replace(/\D/g, ""), null, null, type)
        .then(({ data }) => {
          result = data;
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      return result;
    },

    async findCNPJ(cnpj) {
      this.resultCNPJ = null;
      this.$vs.loading();
      this.showClientForm = false;
      try {
        const response = await CNPJService.getCNPJ(cnpj.replace(/\D/g, ""));
        this.resultCNPJ = response.data;
        this.$vs.loading.close();
      } catch (error) {
        if (error.response?.status === 400) {
          this.errorClient.push("CNPJ inválido");
        } else if (error.response?.status === 404) {
          this.errorClient.push("CNPJ não localizado");
          this.showClientForm = true;
        }
        this.$vs.loading.close();
      }
    },

    async saveClient() {
      const clientData = {
        NOMEFANTASIA: this.client.NOMESOCIAL,
        NOME: this.client.NOME,
        CGCCFO: this.client.CGCCFO.replace(/\D/g, ""),
        TELEFONE: this.client.TELEFONE.replace(/\D/g, ""),
        TELEX: this.client.TELEX.replace(/\D/g, ""),
        EMAIL: this.client.EMAIL,
        PESSOAFISOUJUR: this.client.PESSOAFISOUJUR,
        DTNASCIMENTO: this.client.DTNASCIMENTO,
        CODCOLCFO: this.client.CODCOLIGADA,
        CODCFO: this.client.CODCFO,
        CIDENTIDADE: this.client.RG,
        CEP: this.client.CEP == "-" ? "" : this.client.CEP,
        RUA: this.client.RUA == "-" ? "" : this.client.RUA,
        NUMERO: this.client.NUMERO == "-" ? "" : this.client.NUMERO,
        COMPLEMENTO: this.complement,
        CODETD: this.client.ESTADO == "-" ? "" : this.client.ESTADO,
        CODMUNICIPIO:
          this.client.CODMUNICIPIO == "-" ? "" : this.client.CODMUNICIPIO,
        BAIRRO: this.client.BAIRRO == "-" ? "" : this.client.BAIRRO,
        TIPORUA: this.client.TIPORUA == "-" ? "" : this.client.TIPORUA,
        isNew: this.client.isNew,
      };
      await new PersonService()

        .newClientPerson(clientData)
        .then(({ data }) => {
          const result = data.split(";");
          this.client.CODCFO = result[1];
          this.client.CODCOLCFO = result[0];

          this.success = true;
        })
        .catch(( error ) => {
          this.errorClient.push(
            "Erro na tentativa de criar ou atualizar um registro de cliente: " + error.response.data.error
          );
        });
    },

    async saveAndGoFoward() {
      this.errorClient = [];
      this.validClientData();
      if (this.errorClient.length == 0) {
        this.$vs.loading();
        if (!this.client.CODCFO) this.client.isNew = true;
        else this.client.isNew = false;
        await this.saveClient();

        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style>
.btn-mailing {
  width: 50%;
  margin-top: 0;
}

.vs-input {
  width: 100% !important;
}

a.inline {
  text-decoration-style: solid;
}

.input_container {
  padding-bottom: 32px;
}

.vs-textarea,
.vs-textarea:focus {
  resize: none !important;
}
.input-icon-validate,
.vs-input--icon-validate {
  display: none;
}
.select-faded .vs-select--input,
.con-select .vs-select--label,
.vs-con-input-label.vs-input label.vs-input--label {
  color: rgba(0, 0, 0, 0.6);
}
.w-100 {
  width: 100%;
}

@media screen and (max-width: 600px) {
  .btn-mailing {
    width: 93.5%;
  }
}
</style>
